import { render } from "./IntroComponent.vue?vue&type=template&id=764336d0&scoped=true"
import script from "./IntroComponent.vue?vue&type=script&lang=js"
export * from "./IntroComponent.vue?vue&type=script&lang=js"

import "./IntroComponent.vue?vue&type=style&index=0&id=764336d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764336d0"]])

export default __exports__